import { render } from "./UEInsuranceTransportListView.vue?vue&type=template&id=714ab5a2&scoped=true"
import script from "./UEInsuranceTransportListView.vue?vue&type=script&lang=js"
export * from "./UEInsuranceTransportListView.vue?vue&type=script&lang=js"

import "./UEInsuranceTransportListView.vue?vue&type=style&index=0&id=714ab5a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714ab5a2"]])

export default __exports__